/*@ngInject*/
const FormSetRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.startChanges = function (formSetId) {
        let url = '/rest/FormSet/' + formSetId + '/startChanges';
        return this.post(url);
    };

    this.applyChanges = function (formSetId) {
        let url = '/rest/FormSet/' + formSetId + '/applyChanges';
        return this.post(url);
    };

    this.discardChanges = function (formSetId) {
        let url = '/rest/FormSet/' + formSetId + '/discardChanges';
        return this.post(url);
    };
};

angular.module('umCore')
    .service('formSetRepository', FormSetRepository);
